import React from 'react'
import AppRouter from '../../modules/router/AppRouter'
import Section from '../views/layout/Section'
import AppNavBar from '../templates/app/AppNavBar'
import Main from '../views/layout/Main'

export default ({ userId }) => (
  <Section>
    <AppNavBar />
    <Main>
      <AppRouter userId={userId} />
    </Main>
  </Section>
)



// WEBPACK FOOTER //
// ./src/components/pages/AppPage.js